const MindBord = () => {
    return (
        <div className="mindBord">
            <p>What is In your mind ?</p>
        </div>
    )
}


export default MindBord;